import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ChatMessage {
    id: number|string;
    user_message: string;
    session_header: string;
    bot_response: string;
    star_rating: number | null;
    text_rating: string | null;
    message_type: string;
    abusive: boolean;
    biased: boolean;
    helpful: boolean | null;
    remarks: string | null;
    feedback_form?: any;
    timestamp: string;
    session: number| string;
    user: number|string;
    not_medical_question:boolean;
}

interface ChatError {
    message: string;
    code?: number;
}

interface ChatState {
    loading: boolean;
    error: ChatError | null;
    message_history: ChatMessage[];
}

const initialState: ChatState = {
    loading: false,
    error: null,
    message_history: [],
};

const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        fetchChatMessagesRequest: (state, action: PayloadAction<{ session_id: number | string }>) => {
            state.loading = true;
            state.error = null;
        },
        fetchChatMessagesSuccess: (state, action: PayloadAction<ChatMessage[]>) => {
            state.loading = false;
            state.message_history = action.payload;
        },
        fetchChatMessagesFailure: (state, action: PayloadAction<{ message: string; code?: number }>) => {
            state.loading = false;
            state.error = action.payload;
        },
        clearMessages: (state) => {
            state.message_history = [];
        },
    },
});

export const { fetchChatMessagesRequest, fetchChatMessagesSuccess, fetchChatMessagesFailure, clearMessages } =
    chatSlice.actions;

export const chatReducer = chatSlice.reducer;
export const chatActionTypes = chatSlice.actions;
